'use strict';

var Backbone = require('backbone');
var FormView = require('../../components/Form/FormView');
import {parallelArrayEach} from '../../utilities/uiLoopHelpers';
import Analytics from '../../components/Analytics/Analytics';
import config from '../config';

let InputSearchView = Backbone.View.extend({
  events: {
    'submit form': 'onSubmit',
    'click .Embedded-search-submit': 'onSubmitClick'
  },

  initialize: function() {
    // Create form views
    this.formView = new FormView({
      el: this.$('form'),
      errorPlacement: function() {
        return false;
      }
    });
  },

  onSubmitClick: function() {
    this.$('.Embedded-search-input').focus();
  },

  onSubmit: function() {
    // Check if the form is invalid
    if (this.formView.validator.numberOfInvalids() || !this.$('.Embedded-search-input').val().length) {
      return false;
    }
    Analytics.setOnDataLayer({
      search: {
        advancedSearch: false
      }
    });
    // send analytics event
    Analytics.pushToEventFramework({
      event: config.analytics.events.formSubmission,
      category: this.$el.data('analyticsCategory'),
      action: config.analytics.actions.search,
      label: this.$('.Embedded-search-input').val()
    });
    return true;
  }

}, {
  create: function($parent) {
    parallelArrayEach($parent.find('.Embedded-search-search'), (el) => new InputSearchView({ el: el }));
  }
});

module.exports = InputSearchView;



// WEBPACK FOOTER //
// ./assets/js/components/InputSearchView.js